<!-- smaple table and without checkbox table-->
@if ((dataSource && showHide) || viewForm) {
  <div
    class="shade-white review-each-wrapper mat-elevation-z3 review-sample-wrapper"
    >
    <div class="row">
      <div class="col-md-11">
        <div class="block-wrapper">
          <h2>{{ title }}</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table
          mat-table
          [dataSource]="dataSource"
          id="mat-t"
          class="mat-elevation-z8"
          aria-describedby="sample Information">
          @for (col of headerColumns; track col) {
            <ng-container [matColumnDef]="col.name">
              <th mat-header-cell *matHeaderCellDef>
                @if (col.name !== 'sampleStatusTypeId') {
                  <span>{{ col.displayName }}</span>
                }
              </th>
              <td mat-cell *matCellDef="let element">
                @if (col.name !== 'sampleStatusTypeId') {
                  @if (col.name === 'displayDepth' && element[col.name] !== null) {
                    <span>
                    {{ getDisplayDepth(element) }}</span>
                  }
                  @if (col.name === 'sampleTypeMasterId' && element[col.name] !== null) {
                    <span>
                      {{ getSampleTypeName(element.sampleTypeMasterId) }}
                    </span>
                  }
                  @if (col.name !== 'displayDepth' && element[col.name] !== null && col.name !== 'sampleTypeMasterId') {
                    <span
                      [title]="col.format === 'truncate' && element[col.name] ? element[col.name] : ''"
                      [innerHTML]="(element[col.name] ? element[col.name] : '') | format : col.format">
                    </span>
                  }
                }
              </td>
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
  </div>
}

<!-- smaple table and checkbox table-->
@if (dataSource && !showHide && !viewForm) {
  <div
    class="shade-white review-each-wrapper mat-elevation-z3 review-sample-wrapper"
    >
    <div class="row">
      <div class="col-md-12">
        <div class="block-wrapper">
          <h2>{{ title }}</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="formGroup">
          <table
            mat-table
            [dataSource]="dataSource"
            id="mat-t"
            class="mat-elevation-z8"
            aria-describedby="sample Information">
            @for (col of headerColumns; track col) {
              <ng-container [matColumnDef]="col.name">
                <th mat-header-cell *matHeaderCellDef>{{ col.displayName }}</th>
                <td mat-cell *matCellDef="let element; let i = index" [ngClass]="getCellClass(col.name, element)">
                  @if (col.name === 'sampleStatusTypeId') {
                    @if (isSplit) {
                      <mat-checkbox
                        class="mat-check-cls"
                        [formControlName]="element.id + '_sampleStatusTypeId'"
                        (change)="onCheckboxChange(element)"
                        color="primary"
                        [ngClass]="{ 'split-background': element.isChecked }">
                      </mat-checkbox>
                    }
                    {{ getSampleStatusLabel(element[col.name]) }}
                  }
                  @if (col.name !== 'sampleStatusTypeId') {
                    @if (element.sampleStatusTypeId !== null) {
                      @if (shouldShowCheckbox()) {
                        <mat-checkbox
                          class="mat-check-cls"
                          color="primary"
                          [formControlName]="getControlName(element, col.name)">
                        </mat-checkbox>
                      }
                    }
                    @if (col.name === 'sampleTypeMasterId' && element[col.name] !== null) {
                      <span
                        [ngClass]="getCellColor(i, col.name)">
                        {{ getSampleTypeName(element.sampleTypeMasterId) }}
                      </span>
                    }
                    @if (col.name === 'displayDepth' && element[col.name] !== null) {
                      <span
                        [ngClass]="getCellColor(i, col.name)">
                        {{ getDisplayDepth(element) }}
                      </span>
                    }
                    @if (col.name !== 'displayDepth' && col.name !== 'sampleTypeMasterId') {
                      <span
                        [title]="col.format === 'truncate' ? element[col.name] : ''"
                        [ngClass]="getCellColor(i, col.name)"
                  [innerHTML]="
                    element[col.name] !== null && element[col.name] !== ''
                      ? (element[col.name] | format : col.format)
                      : '---'
                  ">
                      </span>
                    }
                  }
                </td>
              </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns; let i = index"
            [ngClass]="getRowClasses(row)"></tr>
          </table>
        </form>
      </div>
    </div>
  </div>
}
